export const GET_ADMIN_CHATS = '[admin] get chats';
export const GET_ADMIN_RECIPIENTS = '[admin] get recipients';
export const SEND_ADMIN_MESSAGE = '[admin] send message';
export const GET_ADMIN_SETTINGS = '[admin] get settings';
export const UPDATE_ADMIN_SETTINGS = '[admin] update settings';
export const GET_ADMIN_SOLUTIONS = '[admin] get solutions';
export const SET_SOLUTION_APPROVAL = '[admin] set solution approval';

export const getAdminChats = {
    type: GET_ADMIN_CHATS,
};

export const getAdminRecipients = {
    type: GET_ADMIN_RECIPIENTS,
};

export const sendAdminMessage = payload => ({
    type: SEND_ADMIN_MESSAGE,
    payload,
});

export const getAdminSettings = {
    type: GET_ADMIN_SETTINGS,
};

export const updateAdminSettings = payload => ({
    type: UPDATE_ADMIN_SETTINGS,
    payload,
});

export const getAdminSolutions = (onlyPending = false) => ({
    type: GET_ADMIN_SOLUTIONS,
    payload: { onlyPending },
});

export const setSolutionApproval = (solutionId, approved) => ({
    type: SET_SOLUTION_APPROVAL,
    payload: { solutionId, approved },
});
